import React, { useEffect, useState, useRef } from 'react';
import { t } from 'i18next';
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers';
import { useReactToPrint } from 'react-to-print';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import fetchAPI from '../../../common/fetchAPI';
import moment from 'moment';
import InvoicePrintWidget from './InvoicePrintWidget';
import { formatDateWithDateAndMonthName, FormatInvoiceDecimalNumber, getValueFromResource } from '../../../common/timeLiveFunction';
import { updateTimeExpenseBillingIdForPrint } from '../invoiceBillingSlice';
const objRecords = {
    timesheetArray: [],
    masterRecordArray: [],
    expenseArray: [],
    masterArray: [],
    taxArray: [],
    isLoading: true,
    logoPath: ''
}

const InvoicePrintViewWidget = (props: any) => {
    const dispatch = useAppDispatch();
    const { modelRef } = props;
    const componentRef = useRef<HTMLDivElement>(null);
    const { accountTimeExpenseBillingIdForPrint, accountTimeExpenseBillingId, masterAccountTimeExpenseBilling } = useAppSelector((state) => state.invoiceBilling);
    const { decimalPlaces, cultureInfoName, sessionAccountId, showProjectNameInInvoiceReport, showBillingRateInInvoiceReport, showEntryDateInInvoiceReport, showEmployeeNameInInvoiceReport,
        isCompanyOwnLogo, manageTerminologyList
    } = useAppSelector(state => state.globalState);
    const [invoiceDetail, setInvoiceDetail] = useState<any | ''>(objRecords);
    const getMasterRecord: any = masterAccountTimeExpenseBilling[0];

    useEffect(() => {
        if (accountTimeExpenseBillingIdForPrint == '') {
            setInvoiceDetail({ ...objRecords });
            return;
        }
        let isCurrent = true;
        setInvoiceDetail((prev: any) => ({ ...prev, isLoading: true }));
        getAccountInvoiceRecords(accountTimeExpenseBillingIdForPrint, () => !isCurrent);
        return () => {
            isCurrent = false;
        };
    }, [accountTimeExpenseBillingIdForPrint])

    useEffect(() => {
        const modalEl = document.getElementById('invoicePrintModal');
        if (!modalEl) {
            return;
        }
        const onHidden = () => {
            dispatch(updateTimeExpenseBillingIdForPrint(''));
            setInvoiceDetail({ ...objRecords });
        };
        modalEl.addEventListener('hidden.bs.modal', onHidden);
        return () => modalEl.removeEventListener('hidden.bs.modal', onHidden);
    }, [dispatch])

    let object = {
        "AccountName": "",
        "AccountAddress1": "",
        "AccountAddress2": "",
        "City": "",
        "ZipCode": "",
        "AccountCountry": "",
        "Telephone": "",
        "InvoiceNumber": "",
        "PONumber": "",
        "InvoiceDate": "",
        "DueDate": "",
        "ClientName": "",
        "Address1": "",
        "Address2": "",
        "ClientCity": "",
        "ClientState": "",
        "ClientZipcode": "",
        "ClientCountry": "",
        "ClientTelephone": "",
        "ProjectName": "",
        "StartDate": "",
        "EndDate": "",
        "SubTotal": "",
        "Discount": "",
        "GrandTotal": "",
        "TotalTimesheetAmount": "",
        "TotalExpenseAmount": "",
        "CurrencyCode": "",
        // "MasterDescription": ""
        "MasterDescription": undefined,
        "InvoiceNoPrefix": ""
    }

    const timestamp = new Date().getTime();
    const getAccountInvoiceRecords = async (billingId: string, isStale?: () => boolean) => {
        try {
        const response = await fetchAPI(`api/V2/Invoice/GetReportData/${sessionAccountId}/${billingId}/${isCompanyOwnLogo}`, 'Get', '', true);
        const json = await response.json();
        let tempMasterArray: any[] = [];
        let result: any[] = [];
        if (json["TimesheetTax"].length > 0 || json["ExpenseTax"].length > 0) {
            const combinedData = [...json["TimesheetTax"], ...json["ExpenseTax"]];
            const taxSums: any = {};
            combinedData.forEach(item => {
                if (item.TaxCodeName1 != null) {
                    const name1 = item.TaxCodeName1;
                    if (taxSums[name1]) {
                        taxSums[name1] += item.TaxCode1;
                    } else {
                        taxSums[name1] = item.TaxCode1;
                    }
                }
                if (item.TaxCodeName2 != null) {
                    const name2 = item.TaxCodeName2;
                    if (taxSums[name2]) {
                        taxSums[name2] += item.TaxCode2;
                    } else {
                        taxSums[name2] = item.TaxCode2;
                    }
                }
                // if (item.TaxCodeName1 != null && item.TaxCodeName2 != null) {
                //     const name1 = item.TaxCodeName1;
                //     const name2 = item.TaxCodeName2;
                //     if (taxSums[name1]) {
                //         taxSums[name1] += item.TaxCode1;
                //     } else {
                //         taxSums[name1] = item.TaxCode1;
                //     }
                //     if (taxSums[name2]) {
                //         taxSums[name2] += item.TaxCode2;
                //     } else {
                //         taxSums[name2] = item.TaxCode2;
                //     }
                // }
            });
            result = Object.keys(taxSums).map(key => ({
                TaxCodeName: key,
                TotalTaxCode: taxSums[key].toFixed(2)
            }));
        } else {
            result = [];
        }
        if (json["MasterRecord"].length > 0) {
            json["MasterRecord"].map((item: any) => {
                let isInvoiceTemplate = (item.InvoiceTemplateAccountName === "" || item.InvoiceTemplateAccountName === null) ? false : true;
                object.AccountName = isInvoiceTemplate ? item.InvoiceTemplateAccountName : item.AccountName;
                object.AccountAddress1 = isInvoiceTemplate ? item.InvoiceTemplateAddress1 : item.AccountAddress1;
                object.AccountAddress2 = isInvoiceTemplate ? item.InvoiceTemplateAddress2 : item.AccountAddress2;
                object.City = isInvoiceTemplate ? item.InvoiceTemplateCity : item.City;
                object.ZipCode = isInvoiceTemplate ? item.InvoiceTemplateZipCode : item.ZipCode;
                object.AccountCountry = isInvoiceTemplate ? item.InvoiceTemplateCountry : item.AccountCountry;
                object.Telephone = isInvoiceTemplate ? item.InvoiceTemplateTelephone : item.Telephone;
                object.InvoiceNumber = item.InvoiceNumber;
                object.PONumber = item.PONumber;
                // object.InvoiceDate = formatDateWithDateAndMonthName(item.InvoiceDate);
                object.InvoiceDate = formatDateWithDateAndMonthName(item.InvoiceDate, cultureInfoName.toString());
                object.DueDate = formatDateWithDateAndMonthName(item.DueDate, cultureInfoName.toString());
                object.ClientName = item.ClientName;
                object.Address1 = item.Address1;
                object.Address2 = item.Address2;
                object.ClientCity = item.ClientCity;
                object.ClientState = item.ClientState;
                object.ClientZipcode = item.ClientZipcode;
                object.ClientCountry = item.ClientCountry;
                object.ClientTelephone = item.ClientTelephone;
                object.ProjectName = item.ProjectName;
                object.StartDate = formatDateWithDateAndMonthName(item.BillingCycleStartDate, cultureInfoName.toString());//moment(item.BillingCycleStartDate).format("DD/MM/YYYY");
                object.EndDate = formatDateWithDateAndMonthName(item.BillingCycleEndDate, cultureInfoName.toString()); //moment(item.BillingCycleEndDate).format("DD/MM/YYYY");
                object.SubTotal = item.SubTotal.toFixed(2);
                object.Discount = item.Discount.toFixed(2);
                object.GrandTotal = item.GrandTotal.toFixed(2);
                object.CurrencyCode = item.CurrencyCode;
                object.MasterDescription = item["Master Description"].split('\n').map((item: any) => item.trim()).filter((item: any) => item !== '');
                object.InvoiceNoPrefix = item.InvoiceNoPrefix;
            });
            let total = 0;
            json["MasterRecord"].map((item: any) => {
                total = total + item.TotalAmount
            })
            object.TotalTimesheetAmount = total.toFixed(2);
            tempMasterArray.push(object);
        }
        if (json["ExpenseSheet"].length > 0) {
            let total = 0;
            json["ExpenseSheet"].map((item: any) => {
                total = total + Number(item.BilledExpenseAmount);
            })
            object.TotalExpenseAmount = Number(total).toFixed(2);
            if (json["MasterRecord"].length == 0) {
                let taxAmount = 0;
                result.map((item) => {
                    taxAmount = taxAmount + Number(item.TotalTaxCode);
                });
                object.SubTotal = "0";
                object.Discount = "0";
                object.GrandTotal = (total + taxAmount).toString();
            }
            tempMasterArray.push(object);
        }
        if (isStale?.()) {
            return;
        }
        setInvoiceDetail({
            ...invoiceDetail,
            masterRecordArray: json["MasterRecord"],
            expenseArray: json["ExpenseSheet"],
            masterArray: tempMasterArray?.[0] ?? {},
           // masterArray: tempMasterArray[0],
            taxArray: result,
            isLoading: false,
            logoPath: json["ImageURL"] + "?_=" + timestamp,
            timesheetArray: json["Timesheet"]
        });
        } catch (error) {
            if (isStale?.()) {
                return;
            }
            setInvoiceDetail((prev: any) => ({ ...prev, isLoading: false }));
        }
    }

    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    const { masterArray, taxArray, logoPath } = invoiceDetail;

    const getLabelNameFromTerminology = (Value: string) => {
        if (manageTerminologyList && manageTerminologyList.length > 0) {
            for (let manageTerminologyItem of manageTerminologyList) {
                let isManageTerminologyExist: boolean = Value.includes(manageTerminologyItem.TerminologyName);
                if (isManageTerminologyExist) {
                    return Value.replace(Value, manageTerminologyItem.UserDefinedName).toString();
                }
            }
        }
        return Value.toString();
    }

    return (
        <>
            <div className='modal drawer-overlay' tabIndex={-1} data-bs-backdrop="false" id='invoicePrintModal' role="dialog" aria-labelledby="exampleModalSizeSm" aria-hidden="true">
                <div className='modal-dialog modal-xl'>
                    <div className='modal-content rounded'>
                        <div className='modal-header pb-2'>
                            <h3 className='headerTitle'>
                                {/* {t('Invoice Detail')} */}
                                {getValueFromResource('Invoice Detail',dispatch, t)}
                                </h3>
                            <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal'>
                                <KTIcon iconName='cross' className='fs-1' />
                            </div>
                        </div>
                        <div className='modal-body pt-0 pb-15 px-5 px-xl-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
                            {invoiceDetail.isLoading ? <div className="d-flex justify-content-center align-items-center">
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                    <span className='spinner-border spinner-border-md ms-2 mt-12'></span>
                                </span>
                            </div> : <>
                                <div className='row text-left mb-3 mt-3'>
                                        {isCompanyOwnLogo && (
                                            <div className='d-flex justify-content-end'>
                                                <img
                                                    src={logoPath}
                                                    alt={logoPath} style={{ width: '180px', height: '50px' }} />
                                            </div>)}
                                    {/* <img src={toAbsoluteUrl('/media/logos/livetecs-Icon.svg')} className='tsReportIcon'></img> */}
                                    {/* <img src={toAbsoluteUrl('/media/logos/livetecs.svg')} className='tsReportLogo'></img> */}
                                    <div style={{ textAlign: 'right' }}>
                                        <span className='textDarkBlue' style={{ fontWeight: 600, fontSize: 15 }}>{masterArray.AccountName}</span><br />
                                        <span className='reportMLabel'>{masterArray.AccountAddress1}</span><br />
                                        <span className='reportMLabel'>{masterArray.AccountAddress2}</span><br />
                                        <span className='reportMLabel'>{masterArray.City}</span><br />
                                        <span className='reportMLabel'>{`${masterArray.ZipCode}`}</span><br />
                                        <span className='reportMLabel'>{masterArray.AccountCountry}</span><br />
                                        <span className='reportMLabel'>{masterArray.Telephone}</span><br /><br />
                                        <span className='invoiceReportMLabel'>
                                            {/* {t('Invoice No:')}  */}
                                            {getValueFromResource('Invoice No:',dispatch, t)}
                                            </span>
                                        <span className='invoiceReportMText'>{masterArray.InvoiceNoPrefix === '' ? masterArray.InvoiceNumber : masterArray.InvoiceNoPrefix + '-' + masterArray.InvoiceNumber}</span><br />
                                        <span className='invoiceReportMLabel'>
                                            {/* {t('PO Number:')}  */}
                                            {getValueFromResource('PO Number:',dispatch, t)}
                                            </span>
                                        <span className='invoiceReportMText'>{masterArray.PONumber}</span><br />
                                        <span className='invoiceReportMLabel'>
                                            {/* {t('Invoice Date:')}  */}
                                            {getValueFromResource('Invoice Date:',dispatch, t)}
                                            </span>
                                        <span className='invoiceReportMText'>{masterArray.InvoiceDate}</span><br />
                                        <span className='invoiceReportMLabel'>
                                            {/* {t('Due Date:')} */}
                                            {getValueFromResource('Due Date:',dispatch, t)}
                                             </span>
                                        <span className='invoiceReportMText'>{masterArray.DueDate}</span><br />
                                    </div>
                                    <div style={{ marginLeft: -5, marginTop: 20 }}>
                                        <span className='reportTextM'>
                                            {/* {t('Billed To')} */}
                                            {getValueFromResource('Billed To',dispatch, t)}
                                            </span> <br />
                                        <span className='invoiceReportMLabelLeft'>{masterArray.ClientName}</span><br />
                                        <span className='invoiceReportMLabelLeft'>{masterArray.Address1}</span><br />
                                        {masterArray.Address2 != "" && <><span className='invoiceReportMLabelLeft'>{masterArray.Address2}</span><br /></>}
                                        <span className='invoiceReportMLabelLeft'>{`${masterArray.ClientCity} ${masterArray.ClientState}`}</span><br />
                                        <span className='invoiceReportMLabelLeft'>{masterArray.ClientZipcode}</span><br />
                                        <span className='invoiceReportMLabelLeft'>{masterArray.ClientCountry}</span><br />
                                        <span className='invoiceReportMLabelLeft'>{masterArray.ClientTelephone}</span><br /><br />
                                        <span className='reportTextM'>
                                            {/* {t('Billing Period')} */}
                                            {getValueFromResource('Billing Period',dispatch, t)}
                                            </span> <br />
                                        <span className='invoiceReportMLabelLeft' style={{ paddingRight: 4 }}>
                                            {/* {t('Start Date:')} */}
                                            {getValueFromResource('Start Date:',dispatch, t)}
                                            </span>
                                        <span className='invoiceReportMText'>{masterArray.StartDate}</span><br />
                                        <span className='invoiceReportMLabelLeft' style={{ paddingRight: 8 }}>
                                            {/* {t('End Date:')} */}
                                            {getValueFromResource('End Date:',dispatch, t)}
                                            </span>
                                        <span className='invoiceReportMText'>{masterArray.EndDate}</span><br />
                                    </div>
                                </div>
                                {invoiceDetail.timesheetArray.length > 0 && <table className='tsReportCommentTable mb-6'>
                                    <thead>
                                        <tr className='invoiceReportThead'>
                                            {/* {showEntryDateInInvoiceReport && <th className='min-w-100px invoiceTH'>{t('Entry Date')}</th>} */}
                                            {showEntryDateInInvoiceReport && <th className='min-w-100px invoiceTH'>
                                                {/* {t(getLabelNameFromTerminology('Entry Date'))} */}
                                                {getValueFromResource('Entry Date',dispatch, t)}
                                                </th>}
                                            {/* {showEmployeeNameInInvoiceReport && <th className='min-w-100px invoiceTH'>{t('Employee Name')}</th>} */}
                                            {showEmployeeNameInInvoiceReport && <th className='min-w-100px invoiceTH'>
                                                {/* {t(getLabelNameFromTerminology('Employee Name'))} */}
                                                {getValueFromResource('Employee Name',dispatch, t)}
                                                </th>}
                                            {/* {showProjectNameInInvoiceReport && <th className='min-w-100px invoiceTH'>{t('Project Name')} </th>} */}
                                            {showProjectNameInInvoiceReport && <th className='min-w-100px invoiceTH'>
                                                {/* {t(getLabelNameFromTerminology('Project Name'))}  */}
                                                {getValueFromResource('Project Name',dispatch, t)}
                                                </th>}
                                            {/* <th className='min-w-100px invoiceTH'>{t('Description')}</th> */}
                                            <th className='min-w-100px invoiceTH'>
                                                {/* {t(getLabelNameFromTerminology('Description'))} */}
                                                {getValueFromResource('Description',dispatch, t)}
                                                </th>
                                            {/* {showBillingRateInInvoiceReport && <th className='min-w-100px invoiceTH text-right'>{t('Billing Rate')}</th>} */}
                                            {showBillingRateInInvoiceReport && <th className='min-w-100px invoiceTH text-right'>
                                                {/* {t(getLabelNameFromTerminology('Billing Rate'))} */}
                                                {getValueFromResource('Billing Rate',dispatch, t)}
                                                </th>}
                                            {/* <th className='min-w-100px invoiceTH text-right'>{t('Billing Hours')}</th> */}
                                            <th className='min-w-100px invoiceTH text-right'>
                                                {/* {t(getLabelNameFromTerminology('Billing Hours'))} */}
                                                {getValueFromResource('Billing Hours',dispatch, t)}
                                                </th>
                                            {/* <th className='min-w-100px invoiceTH text-right'>{t('Billing Amount')}</th> */}
                                            <th className='min-w-100px invoiceTH text-right'>
                                                {/* {t(getLabelNameFromTerminology('Billing Amount'))} */}
                                                {getValueFromResource('Billing Amount',dispatch, t)}
                                                </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {invoiceDetail.timesheetArray.length > 0 && invoiceDetail.timesheetArray.map((item: any, index: number) => {
                                            return (
                                                <tr key={index} className='tsReportCommentTbody'>
                                                    {/* {showEntryDateInInvoiceReport && <td className='paddingLeft'>{getMasterRecord.GroupTimesheetBillingListBy === "TimeEntry" ? moment(item.TimeEntryDate).format('YYYY-MM-DD') : ""}</td>} */}
                                                    {showEntryDateInInvoiceReport && <td className='paddingLeft'>{item.TimeEntryDate ? moment(item.TimeEntryDate).format('DD/MM/YYYY') : ""}</td>}
                                                    {/* {showEmployeeNameInInvoiceReport && <td className='paddingLeft'>{getMasterRecord.GroupTimesheetBillingListBy === "TimeEntry" ? item.EmployeeName : ""}</td>} */}
                                                    {/*{showEmployeeNameInInvoiceReport && <td className='paddingLeft'>{getMasterRecord.GroupTimesheetBillingListBy === "TimeEntry" || getMasterRecord.GroupTimesheetBillingListBy === "Employee" ? item.EmployeeName : ""}</td>}*/}
                                                    {showEmployeeNameInInvoiceReport && <td className='paddingLeft'>{item.EmployeeName ? item.EmployeeName : ""}</td>}
                                                    {showProjectNameInInvoiceReport && <td className='paddingLeft'>{item.ProjectName}</td>}
                                                    <td className='paddingLeft'>{item['Detail Description']}</td>
                                                    {showBillingRateInInvoiceReport && <td className='paddingLeft text-right'>{item.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.ActualBillingRate, decimalPlaces)}</td>}
                                                    <td className='paddingLeft text-right'>{FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.BillHours , 2)}</td>
                                                    <td className='paddingLeft text-right'>{item.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.TotalAmount, decimalPlaces)}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            {showEntryDateInInvoiceReport && <td></td>}
                                            {showEmployeeNameInInvoiceReport && <td></td>}
                                            {showProjectNameInInvoiceReport && <td></td>}
                                            <td></td>
                                            {showBillingRateInInvoiceReport && <td></td>}
                                            <td></td>
                                            <td className='paddingLeft text-right' style={{ height: 50 }}>
                                                {/* <span>{'Total:'}</span> */}
                                                <span className='invoiceReportText' style={{ fontWeight: 600 }}>{masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.TotalTimesheetAmount, decimalPlaces)}</span>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>}
                                {invoiceDetail.expenseArray.length > 0 && <table className='tsReportCommentTable mb-6'>
                                    <thead>
                                        <tr className='invoiceReportThead'>
                                            {/* {showProjectNameInInvoiceReport && <th className='invoiceTH' style={{ width: '50%' }}>{t('Project Name')}</th>} */}
                                            {showProjectNameInInvoiceReport && <th className='invoiceTH' style={{ width: '50%' }}>
                                                {/* {t(getLabelNameFromTerminology('Project Name'))} */}
                                                {getValueFromResource('Project Name',dispatch, t)}
                                                </th>}
                                            {/* <th className='invoiceTH' style={{ width: '30%' }}>{t('Expense Description')}</th> */}
                                            <th className='invoiceTH' style={{ width: '30%' }}>
                                                {/* {t(getLabelNameFromTerminology('Expense Description'))} */}
                                                {getValueFromResource('Expense Description',dispatch, t)}
                                                </th>
                                            {/* <th className='invoiceTH text-right' style={{ width: '20%' }}>{t('Billed Amount')}</th> */}
                                            <th className='invoiceTH text-right' style={{ width: '20%' }}>
                                                {/* {t(getLabelNameFromTerminology('Billed Amount'))} */}
                                                {getValueFromResource('Billed Amount',dispatch, t)}
                                                </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {invoiceDetail.expenseArray.length > 0 && invoiceDetail.expenseArray.map((item: any, index: number) => {
                                            return (
                                                <tr key={index} className='tsReportCommentTbody'>
                                                    {showProjectNameInInvoiceReport && <td className='paddingLeft' style={{ paddingLeft: 10 }}>{item.ProjectName}</td>}
                                                    <td className='paddingLeft'>{item.Description}</td>
                                                    <td className='paddingLeft text-right'>{item.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.BilledExpenseAmount, decimalPlaces)}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            {showProjectNameInInvoiceReport && <td></td>}
                                            <td></td>
                                            <td className='paddingLeft text-right' style={{ height: 50 }}>
                                                {/* <span>{'Total:'}</span> */}
                                                <span className='invoiceReportText' style={{ fontWeight: 600 }}>{masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.TotalExpenseAmount, decimalPlaces)}</span>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>}
                                <div style={{ textAlign: 'right' }}>
                                    <span className='invoiceReportMLabel'>
                                        {/* {t('Sub Total:')}  */}
                                        {getValueFromResource('Sub Total:',dispatch, t)}
                                        </span>
                                    <span className='invoiceReportTextMFooter mb-2'>{masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.SubTotal, decimalPlaces)}</span><br />
                                        <span className='invoiceReportMLabel'>
                                            {/* {'Discount:'} */}
                                            {getValueFromResource('Discount',dispatch, t)}
                                        </span>
                                    <span className='invoiceReportTextMFooter mb-2'>{"- " + masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.Discount, decimalPlaces)}</span><br />
                                    {taxArray.length > 0 && taxArray[0].TaxCodeName != "null" && taxArray.map((item: any, index: number) => {
                                        return (<><span className='invoiceReportMLabel' style={{ paddingLeft: 6 }}>
                                            {getValueFromResource(item.TaxCodeName, dispatch,t) + ":"} </span>
                                            <span className='invoiceReportTextMFooter mb-2'>{masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.TotalTaxCode, decimalPlaces)}</span><br /></>
                                        )
                                    })}
                                    <span style={{ borderTop: '1px solid #172b4d', borderBottom: '1px solid #172b4d', padding: '6px 0' }}>
                                        <span className='invoiceReportMLabel' >
                                            {/* {t('Grand Total: ')}  */}
                                            {getValueFromResource('Grand Total:',dispatch, t)}
                                            </span>
                                        <span className='invoiceReportTextMFooter'>{masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.GrandTotal, decimalPlaces)}</span>
                                    </span>
                                </div>
                                <div>
                                    {masterArray.MasterDescription != undefined && masterArray.MasterDescription.map((item: any, index: any) => (
                                        <p key={index} style={{ whiteSpace: 'pre-wrap' }}>
                                            {item.replace(/\t+/g, ' ').trim()}
                                        </p>
                                    ))}
                                </div>
                            </>}
                        </div>
                        <div className="modal-footer">
                            <a onClick={() => { handlePrint() }} className={"btn btn-primary btn-sm "}>
                                <i className="bi bi-printer fs-5 me-1"></i> 
                                {/* {t('Print Invoice')} */}
                                {getValueFromResource('Print Invoice',dispatch, t)}
                            </a>
                        </div>
                    </div>
                </div>
                <div style={{ display: 'none' }}> <InvoicePrintWidget ref={componentRef}  {...invoiceDetail} /></div>
            </div>
        </>
    )
}

export default InvoicePrintViewWidget